export default __webpack_public_path__ + "static/media/select-arrow-down.15b0620e.svg";